import { Users, ShieldCheck, BookOpenCheck, GraduationCap, Library, HeartPulse, Scale, Briefcase, Award, CloudRain, HardHat, Cpu, BarChart3, ClipboardList, Wheat, Database, ReceiptText, Shield } from "lucide-react";

export const CERTS = [
  { icon: Award, name: "ACIEH — Associate, Chartered Institute of Environmental Health", issuer: "Chartered Institute of Environmental Health, United Kingdom" },
  { icon: Briefcase, name: "CAPM — Certified Associate in Project Management", issuer: "Project Management Institute (PMI)" },
  { icon: ShieldCheck, name: "ISO 27001/27701 — Information Security & Privacy Management", issuer: "GDPR & PII privacy standards compliance" },
  { icon: BookOpenCheck, name: "CKM — Certified Knowledge Manager", issuer: "Knowledge Management Institute, USA" },
  { icon: GraduationCap, name: "MSc Environmental Management (GIS & Climate Change)", issuer: "Coventry University, United Kingdom — 2012" },
  { icon: Library, name: "B.Tech Urban & Regional Planning", issuer: "Federal University of Technology, Minna — 2008" },
];

/* ─── COMPLETED TRAINING COURSES ─── */
export const TRAINING = [
  { name: "Certificate in Contract Management & Procurement", issuer: "Coventry University, UK — 2019" },
  { name: "Certificate in Community Preparedness, Recovery & Resilience", issuer: "Coventry University, UK — 2019" },
  { name: "Certificate in Understanding Development Management", issuer: "The Open University, UK — 2019" },
  { name: "Certificate in Disaster Management & Humanitarian Aid", issuer: "Deakin University, Australia — 2016" },
  { name: "Certificate in Gender & Development", issuer: "Deakin University, Australia — 2019" },
];

/* ─── PROFESSIONAL TRAINING & COURSES (by domain) ─── */
export const TRAINING_CATEGORIES = [
  {
    icon: Scale, title: "Governance, GESI, Advocacy, Education & Anti-Trafficking",
    courses: [
      { name: "Understanding Elections & Civic Responsibility", meta: "YALI · 2016" },
      { name: "Code of Conduct & Anti-Trafficking", meta: "RTI · 2018" },
      { name: "Understanding the Rights of Women & Girls", meta: "YALI · 2018" },
      { name: "Snapshot of School Management Effectiveness", meta: "RTI International · 2014" },
      { name: "Anti-Trafficking", meta: "Creative University · 2018" },
      { name: "Harassment: Sex, Religion & Beyond", meta: "Creative · 2017" },
      { name: "Early Grade Reading Assessment", meta: "RTI International · 2014" },
      { name: "The Art of Advocacy", meta: "TechChange · 2015" },
    ],
  },
  {
    icon: CloudRain, title: "Climate Change, WASH, GIS & Renewable Energy",
    courses: [
      { name: "Climate Justice – Lessons from the Global South", meta: "UNESCO · 2016" },
      { name: "Global Systems Science & Policy", meta: "UNESCO UNITWIN · 2016" },
      { name: "Understanding Climate Change", meta: "YALI · 2016" },
      { name: "International Environmental Governance", meta: "UNITAR · 2012" },
      { name: "Learning ArcGIS Desktop", meta: "ESRI · 2012" },
      { name: "Recovery Strategy & Contingency Planning", meta: "ECRMI · 2010" },
      { name: "Climate Change Adaptation & Disaster Management", meta: "ECRMI · 2010" },
      { name: "Adapting to Climate Change", meta: "Mott MacDonald, UK · 2014" },
      { name: "Population, Health & Environment", meta: "USAID · 2010" },
      { name: "Governance in Urban Sanitation", meta: "UNITAR · 2011" },
      { name: "Understanding Renewable Energy", meta: "YALI · 2017" },
    ],
  },
  {
    icon: HeartPulse, title: "Public Health",
    courses: [
      { name: "Knowledge Management in Global Health Programs", meta: "USAID · 2016" },
      { name: "Geographic Approaches to Global Health", meta: "USAID · 2011" },
      { name: "Logistics for Health Commodities", meta: "USAID · 2011" },
      { name: "Demography, Health Surveys (DHS) & Data Use", meta: "USAID · 2011" },
      { name: "Online Communities of Practice for Global Health", meta: "USAID · 2016" },
      { name: "Health Commodities", meta: "USAID · 2011" },
      { name: "Meritorious Achievement in Global Health", meta: "USAID · 2011" },
      { name: "Social Media for Health & Development", meta: "USAID · 2016" },
    ],
  },
  {
    icon: Briefcase, title: "Private Sector Engagement & Entrepreneurship",
    courses: [
      { name: "Basics of Public Private Partnerships", meta: "YALI · 2016" },
      { name: "Business & Entrepreneurship", meta: "YALI · 2016" },
      { name: "Business Expansion", meta: "YALI · 2016" },
      { name: "Creating & Maintaining Social Enterprises", meta: "YALI · 2016" },
      { name: "Strengthening Public Sector Service", meta: "YALI · 2016" },
      { name: "Workforce Collaboration & Development", meta: "YALI · 2016" },
      { name: "Fundraising Concepts", meta: "YALI · 2016" },
      { name: "Strategies for Professional Growth & Development", meta: "YALI · 2016" },
      { name: "Fundamentals of Starting & Running a Business", meta: "YALI · 2016" },
      { name: "Business Ethics: Getting It Right", meta: "Mott MacDonald, UK · 2014" },
    ],
  },
  {
    icon: Shield, title: "Stabilization & Countering Violent Extremism (CVE)",
    courses: [
      { name: "Preventing & Countering Violent Extremism", meta: "AU / KAIPTC Ghana · 2017" },
      { name: "Advanced Stabilization & Reintegration", meta: "KAIPTC Ghana · 2017" },
      { name: "Disarmament, Demobilization & Reintegration", meta: "KAIPTC Ghana · 2017" },
      { name: "Intervention & Management in DDR & Peacekeeping", meta: "POTI · 2017" },
      { name: "Hostile Environment Awareness Training", meta: "Salama Fikira · 2018" },
      { name: "HEAT — Planning Your Security", meta: "Creative · 2018" },
      { name: "HEAT — Field Communications", meta: "Creative · 2018" },
    ],
  },
  {
    icon: HardHat, title: "Organizational Health, Safety & Environment (OHSE)",
    courses: [
      { name: "Personal Safety & Security", meta: "SCI · 2020" },
      { name: "Security Awareness", meta: "RTI · 2018" },
      { name: "Site Safety Awareness", meta: "Mott MacDonald, UK · 2014" },
      { name: "Health & Safety Risk Assessment Training", meta: "Mott MacDonald, UK · 2014" },
      { name: "Safe by Design", meta: "Mott MacDonald Inc. USA · 2015" },
      { name: "Circles of Protection (IM50081)", meta: "Mott MacDonald · 2015" },
      { name: "The Safe Way to Work", meta: "Mott MacDonald, UK · 2014" },
      { name: "The Cost of Accidents", meta: "Mott MacDonald, UK · 2014" },
      { name: "Travel Security", meta: "Mott MacDonald, UK · 2014" },
    ],
  },
  {
    icon: ReceiptText, title: "Procurement, Financial Reporting & Grants Management",
    courses: [
      { name: "Fundamentals of Grants Management", meta: "Creative · 2017" },
      { name: "Procurement Solicitation", meta: "Creative · 2017" },
      { name: "Grants Solicitation", meta: "Creative · 2017" },
      { name: "Financial Management Reporting", meta: "Last Mile Learning · 2017" },
      { name: "Grants Monitoring", meta: "Creative · 2017" },
      { name: "Procurement Preparation & Planning", meta: "Creative · 2017" },
      { name: "Procurement Process", meta: "Creative · 2017" },
      { name: "Public Procurement Monitoring", meta: "World Bank / CIPSM · 2013" },
      { name: "Procurement Evaluation", meta: "Creative · 2017" },
      { name: "Procurement Thresholds", meta: "Creative · 2017" },
      { name: "Grants Close-out", meta: "Creative University · 2017" },
      { name: "Fraud Awareness", meta: "Creative · 2017" },
    ],
  },
  {
    icon: Users, title: "Leadership, Public Management, Mentorship & Volunteering",
    courses: [
      { name: "The Fundamentals of Leadership", meta: "MSI · 2019" },
      { name: "Corporate Ethics", meta: "RTI · 2018" },
      { name: "Volunteering & Employability Training", meta: "CUSU Limited, UK · 2012" },
      { name: "Mentoring, Coaching & Volunteer Management", meta: "CUSU Limited, UK · 2012" },
      { name: "Responsible Leadership on Transparency & Good Governance", meta: "YALI · 2017" },
      { name: "Dependency to Partnership: Leading & Managing Change", meta: "USAID · 2016" },
      { name: "Dependency to Partnership: It's About Change", meta: "USAID · 2016" },
      { name: "Leadership for Young Professionals", meta: "Mott MacDonald Inc. USA · 2015" },
      { name: "Civic Leadership", meta: "YALI · 2016" },
      { name: "Community Organizing for Action", meta: "YALI · 2016" },
      { name: "Servant Leadership", meta: "YALI · 2016" },
      { name: "Management Strategies for People & Resources", meta: "YALI · 2016" },
      { name: "Performance Development Review (Reviewee)", meta: "Mott MacDonald, UK · 2014" },
      { name: "Coaching for Results", meta: "Last Mile Learning · 2014" },
      { name: "Project Leadership & Development", meta: "READ International, UK · 2012" },
      { name: "Dynamic Development", meta: "RTI · 2018" },
    ],
  },
  {
    icon: Cpu, title: "AI & Data Protection",
    courses: [
      { name: "ISO 27701 — Data Protection & Privacy Management", meta: "Alison · 2026" },
      { name: "Applied AI for Social Good", meta: "PoliSync · 2026" },
      { name: "AI Foundations — Ethics, Governance & Prompting", meta: "PoliSync · 2026" },
      { name: "AI for Research, Insights & Data", meta: "PoliSync · 2026" },
      { name: "AI-Powered Content, Storytelling & Advocacy", meta: "PoliSync · 2026" },
      { name: "AI for Operations, Admin & Planning", meta: "PoliSync · 2026" },
      { name: "Data Protection & Mobile Device Safety", meta: "MSI · 2019" },
      { name: "Introduction to GDPR", meta: "UCL · 2018" },
      { name: "Handling Sensitive Information", meta: "Creative University · 2018" },
      { name: "Personally Identifiable Information", meta: "MSI · 2019" },
    ],
  },
  {
    icon: BarChart3, title: "Monitoring, Evaluation, Research & Learning (MERL)",
    courses: [
      { name: "Improving Writing Skills: Effective Report Writing", meta: "RTI · 2019" },
      { name: "Managing Performance & Evidence-Based Management", meta: "MSI · 2019" },
      { name: "Making Complex Evaluation Decisions", meta: "RTI · 2018" },
      { name: "SoGo Survey Training", meta: "MSI · 2019" },
      { name: "Monitoring, Evaluation & Learning", meta: "RTI · 2018" },
      { name: "Ethical Research Policy", meta: "MSI · 2019" },
      { name: "Quality Deliverables", meta: "RTI · 2018" },
      { name: "Change Management", meta: "RTI · 2018" },
      { name: "Ethics & Professional Conduct in the Field", meta: "Creative University · 2017" },
      { name: "Making Logic Models Work for You", meta: "CES · 2015" },
      { name: "Evaluation Planning & Management", meta: "USAID / MEMS · 2015" },
      { name: "Data Visualization", meta: "USAID · 2016" },
      { name: "Data Use for Program Managers", meta: "USAID · 2011" },
      { name: "Data Quality", meta: "USAID · 2010" },
      { name: "Economic Evaluation Basics", meta: "USAID · 2011" },
      { name: "Gender Monitoring & Evaluation", meta: "USAID · 2016" },
      { name: "M&E Frameworks for HIV/AIDS Programs", meta: "USAID · 2016" },
      { name: "Demystifying M&E for Practitioners", meta: "USIP · 2015" },
      { name: "M&E of Holistic Early Child Care Development", meta: "USAID · 2016" },
      { name: "Monitoring & Evaluation Fundamentals", meta: "USAID · 2010" },
    ],
  },
  {
    icon: ClipboardList, title: "Project Management, Contracting & Performance",
    courses: [
      { name: "Effective Project Management & Compliance", meta: "MSI · 2019" },
      { name: "Contractor Performance Assessment Reporting", meta: "MSI · 2019" },
      { name: "Standard Operating Procedures Training", meta: "MSI · 2019" },
      { name: "Performance Management for NGOs & CBOs", meta: "Last Mile Learning · 2014" },
      { name: "Project Control: Let's Talk (GPEL0315)", meta: "Mott MacDonald · 2015" },
      { name: "Systematic Management Failure", meta: "Mott MacDonald, UK · 2014" },
      { name: "Performance & Development for Reviewers", meta: "Mott MacDonald, UK · 2014" },
      { name: "Your Performance & Development Review", meta: "Mott MacDonald · 2014" },
      { name: "Passport for Project Directors", meta: "Mott MacDonald, UK · 2014" },
      { name: "Certified Project Management Professional", meta: "AFRIHUB · 2010" },
      { name: "Non-Profit Management (PPME) for Impact", meta: "YAC · 2010" },
      { name: "Basic Measurement Concepts in Six Sigma", meta: "Mott MacDonald, UK · 2014" },
    ],
  },
  {
    icon: Wheat, title: "Food Security & Livelihoods, Nutrition & Cash Transfers",
    courses: [
      { name: "Nutrition – An Introduction", meta: "USAID · 2014" },
      { name: "Conditional Cash Transfer & Cash-Based Intervention", meta: "ACF USA · 2014" },
      { name: "Community Management of Acute Malnutrition (CMAM)", meta: "SCI UK · 2014" },
      { name: "SPHERE Handbook in Action", meta: "The Sphere Project · 2014" },
      { name: "Household Economic Analysis (HEA) Baseline", meta: "SCI UK / FEG · 2014" },
    ],
  },
  {
    icon: Database, title: "Risk, Information Management & Social Media Engagement",
    courses: [
      { name: "Records Management Basics", meta: "RTI · 2018" },
      { name: "Sensitive Information Policy", meta: "RTI · 2018" },
      { name: "Quality Management Systems", meta: "RTI · 2018" },
      { name: "Financial Management", meta: "Last Mile Learning · 2017" },
      { name: "Data Collection Using FS Mobile App", meta: "RTI International · 2015" },
      { name: "Information Management", meta: "Mott MacDonald, UK · 2014" },
      { name: "Mobile Data Solutions", meta: "TechChange · 2015" },
      { name: "Information Management System", meta: "Mott MacDonald, UK · 2014" },
      { name: "Integrated Management Systems (IMS) Overview", meta: "Mott MacDonald, UK · 2014" },
      { name: "Introduction to Information Management (GPEL0069)", meta: "Mott MacDonald, UK · 2014" },
      { name: "Social Media from a Security Perspective", meta: "MSI · 2019" },
      { name: "Social Networking & Engineering", meta: "MSI · 2019" },
    ],
  },
];
